export default __webpack_public_path__ + "static/media/ksLogoDark.0611ec11.svg";